<div class="container">
  <div class="flex items-center justify-between">
    <h5 class="title-header">Program Parameters</h5>
    <button mat-flat-button color="primary" matRipple class="flex items-center" (click)="openModal()">
      <mat-icon style="margin-right: 0.5rem">create</mat-icon>
      Edit
    </button>
  </div>
</div>

<app-program-details [program]="program"></app-program-details>

<app-program-sites [program]="program" (programSitesEmitter)="processNewSites($event)"></app-program-sites>
<app-map *ngIf="mapLocations?.length > 0" [mapLocations]="mapLocations"></app-map>

